import { useEffect, useRef } from 'react'
import { useWalletAuth, WalletType } from '../../auth/useWalletAuth'
import { Spinner } from '../common/Spinner'

interface Props {
  walletType: WalletType
}

const STEP_LABELS: Record<string, string> = {
  connecting: 'Opening wallet…',
  signing:    'Sign the message in your wallet…',
  verifying:  'Verifying signature…',
}

export function SigningPage({ walletType }: Props) {
  const { connect, state, error } = useWalletAuth()
  const fired = useRef(false)

  useEffect(() => {
    if (fired.current) return
    fired.current = true
    // Clean the signin param from the URL so it doesn't persist after auth
    const url = new URL(window.location.href)
    url.searchParams.delete('signin')
    window.history.replaceState({}, '', url.pathname + (url.search || ''))
    connect(walletType)
  }, [walletType]) // eslint-disable-line react-hooks/exhaustive-deps

  const walletName = walletType === 'phantom' ? 'Phantom' : 'Solflare'

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 px-4">
      <span className="font-display text-sm font-bold tracking-widest text-accent-blue select-none">
        SOLQUANT
      </span>

      {error ? (
        <div className="flex flex-col items-center gap-4 text-center max-w-xs">
          <p className="text-sm text-accent-red">{error}</p>
          <button
            onClick={() => connect(walletType)}
            className="bg-accent-purple hover:bg-accent-purple/90 text-white text-sm font-medium px-5 py-2 rounded-md transition-colors"
          >
            Retry with {walletName}
          </button>
          <a
            href="https://solquant.ai"
            className="text-xs text-ink-muted hover:text-ink transition-colors"
          >
            ← Back to solquant.ai
          </a>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-3 text-center">
          <Spinner size="md" />
          <p className="text-sm text-ink-muted">
            {STEP_LABELS[state] ?? `Connecting ${walletName}…`}
          </p>
        </div>
      )}
    </div>
  )
}